module.exports = __webpack_public_path__ + "media/images/ic-entrega-731a842d2dee6ff4f03da2436ace64e6.png";